export function navigateToTargetLevel(level, scope, urls, shouldReplace = false) {
  if (shouldReplace) {
    scope.history.replace({
      pathname: urls[level],
      search: scope.stringify(),
    });
    return;
  }
  scope.save(urls[level]);
}
